import React from 'react'
import { withTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

class Error extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    async componentDidMount() {}

    render() {
        const { t } = this.props

        return (
            <div className="error-box">
                <Helmet>
                    <title>{t('_pages._error.title')} | Interacty</title>
                </Helmet>
                <div className="error-box_code">500</div>
                <div className="error-box_content">
                    <div className="error-box_content--text">{t('_pages._error.error_message')}</div>
                    <div className="error-box_content--link">
                        <Link to="/">{t('_pages._error.go_home')}</Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation('translations')(Error)
